import { render, staticRenderFns } from "./LearningUnitStatusBadge.vue?vue&type=template&id=293c7124&"
import script from "./LearningUnitStatusBadge.vue?vue&type=script&lang=js&"
export * from "./LearningUnitStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports